import React from 'react';

import {ModalPopup, useToast} from '@kit';

import {useCharacter} from '../../character-context';
import {EquippedItem, identifyEntry, isMagicRarity} from '../../model/equipment';
import {withJournalEntry} from '../../model/journal';
import {ItemPickButton} from '../item-search/item-pick-button';
import {ItemSearchList} from '../item-search/item-search-list';
import type {SearchItem} from '../item-search/use-item-search';

import css from '../sheet.module.css';

type Props = {
	equipped: EquippedItem;
	onClose(): void;
};

const isMagicItem = (item: SearchItem) => isMagicRarity(item.rarity);

/** немагический предмет из снаряжения оказывается магическим: игрок находит его в базе и заменяет */
export const IdentifyItemModal: React.FC<Props> = ({equipped, onClose}) => {
	const {update} = useCharacter();
	const toast = useToast();
	const {entry, item} = equipped;

	const identify = (found: SearchItem, itemId: string, baseItemId?: string) => {
		update((current) => ({
			equipment: identifyEntry(current.equipment, entry.key, itemId, baseItemId),
			...withJournalEntry(current, {kind: 'item', title: 'Опознание', details: `${item.title} → ${found.title}`}),
		}));
		toast.show({intent: 'success', title: 'Предмет опознан', body: `${item.title} — это ${found.title}`});
		onClose();
	};

	return (
		<ModalPopup open onClose={onClose} header={`Опознать: ${item.title}`} maxWidth={720}>
			<p className={css.muted}>
				Найдите, чем на самом деле оказался предмет.
				{entry.quantity > 1 && ' Опознаётся один предмет из стопки.'}
			</p>
			<ItemSearchList
				placeholder="Найти магический предмет"
				filter={isMagicItem}
				renderAction={(found) => (
					<ItemPickButton
						item={found}
						preferredBaseId={item.id}
						onPick={(itemId, baseItemId) => identify(found, itemId, baseItemId)}
					>
						Это он
					</ItemPickButton>
				)}
			/>
		</ModalPopup>
	);
};
